import { l as i } from "../../../index-cWJIh2Ap.js";
import { u as n } from "../../../index-bHb0S7Ec.js";
import { styled as t } from "styled-components";
const p = t.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin-top: 1px;
  width: 100%;
  gap: 5px;
`, m = t.img`
  height: 20px;
  width: 105px;
  margin-left: ${i["--ll-spacing-base-unit"]};
`, a = t(n)`
  line-height: initial;
`;
export {
  p as Attribution,
  m as AttributionImg,
  a as Text
};
